
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVolumeOff as ObiVolumeOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-volume-off.js';
 
 
 

 
 export const ObiVolumeOff = createComponent({
   react: React,
   tagName: 'obi-volume-off',
   elementClass: ObiVolumeOffElement,
   events: {
     
   }
  });
 
 